import { zIndex } from "@nova/constants"
import Image from "next/image"
import { useLoadingText } from "features/data-management/workspace/workspace/useLoadingText"

export const SystemInitializingContainer = ({
    title = "Initializing the system",
}: {
    title?: string
}) => {
    const loadingText = useLoadingText(true, title)

    return (
        <div
            className="nova-initializing"
            style={{ zIndex: zIndex.SystemInitializing, position: "absolute", width: "100vw" }}
        >
            <div className="flex flex-col gap-8 items-center w-[16.5rem] h-[14.625rem] bg-black-800 backdrop-blur-sm px-4 py-10 border border-gray-700 rounded-xl">
                <div className="loader" />
                <div>
                    <Image
                        height="27"
                        width="110"
                        alt="nova logo"
                        src={"/images/logos/nova-logo-with-title.svg"}
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                            margin: "auto",
                        }}
                        priority={true}
                    />
                    <h5 className="text-gray-300 mt-3">{loadingText}</h5>
                </div>
            </div>
        </div>
    )
}

export default SystemInitializingContainer
